//Get Current Font
const currentThemeFonts = localStorage.getItem('fontSelect')

// Primary Fonts
const allPrimaryThemeFonts = {
  'Montserrat': "'Montserrat','sans-serif'",
  'Roboto': "'Roboto','sans-serif'",
  'Open Sans': "'Open Sans','sans-serif'",
  'Segoe UI': "'Segoe UI','sans-serif'"
}

const primaryFontFamily =
  allPrimaryThemeFonts[currentThemeFonts] || allPrimaryThemeFonts['Montserrat']

// Secondary fonts
const secondaryFontFamily = "'Lato', 'sans-serif'"

/**
 * Typography for the application based on
 * https://docs.google.com/spreadsheets/d/10B3BkA8uG4L2pd878vJ1TThtuYE3dPnhTqpOEWveXMk
 */
export const Typography = {
  h1: {
    fontFamily: primaryFontFamily,
    fontSize: '20px',
    fontWeight: '600'
  },
  h2: {
    fontFamily: primaryFontFamily,
    fontSize: '20px',
    fontWeight: '500'
  },
  h3: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '14px',
    fontWeight: '700'
  },
  h4: {
    fontFamily: primaryFontFamily,
    fontSize: '14px',
    fontWeight: '500'
  },
  h5: {
    fontFamily:
      primaryFontFamily ===
      (allPrimaryThemeFonts['Montserrat'] || allPrimaryThemeFonts['Roboto'])
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '12px',
    fontWeight: '600'
  },
  h6: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '10px',
    fontWeight: '400'
  },
  h7: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '12px',
    fontWeight: '400'
  },
  h8: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '20px',
    fontWeight: '700'
  },
  h9: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '14px',
    fontWeight: '700'
  },
  h10: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '20px',
    fontWeight: '600'
  },
  h11: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '12px',
    fontWeight: '500'
  },
  h13: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '13px',
    fontWeight: '400'
  },
  p: {
    fontFamily:
      primaryFontFamily === allPrimaryThemeFonts['Montserrat']
        ? secondaryFontFamily
        : primaryFontFamily,
    fontSize: '14px',
    fontWeight: '400'
  }
}
